import React from 'react'
import Hero from './Hero'
import ApplicationForm from './ApplicationForm'
import Layout from '~shared/Layout'
import Spacer from '~shared/Spacer'
import { FaqItem } from '~shared/Faq'
import PersonaPageFaq from '~shared/PersonaPage/PersonaPageFaq'

const DataFund = (props) => (
    <Layout {...props} $backgroundColor="#f5f5f5">
        <Hero />
        <div id="application-form" />
        <ApplicationForm />
        <Spacer pad head="0" tail="10rem,,">
            <PersonaPageFaq title={<>Streamr Data Fund&nbsp;FAQ</>}>
                <FaqItem
                    openOnMount
                    question={
                        <>
                            I&apos;ve submitted my proposal, what happens next and how are funding
                            decisions reached?
                        </>
                    }
                >
                    <p>
                        A member of the Streamr team will be in touch to acknowledge receipt of your
                        proposal and arrange an informal call to discuss it. Once the terms are
                        finalised, a decision on funding is reached. The aim is always for a quick
                        turnaround so successful projects can start building right&nbsp;away.
                    </p>
                </FaqItem>
                <FaqItem question={<>Does my project have to use&nbsp;Streamr?</>}>
                    <p>
                        Yes. The Data fund was created to support initiatives that utilise or
                        promote the Streamr stack or contribute closely to the aims of
                        the&nbsp;project.
                    </p>
                </FaqItem>
                <FaqItem question={<>Who can apply for&nbsp;funding?</>}>
                    <p>
                        Funds are available for any person, team, or company with a viable idea that
                        supports the Streamr project, makes use of its tech stack, and upholds an
                        ethical and transparent standard of data management. The Data Fund is also
                        here for quick response grants under $5000 that can be used for a variety of
                        initiatives by devs or the community.
                    </p>
                </FaqItem>
                <FaqItem question={<>Does my project need to be open&nbsp;source?</>}>
                    <p>
                        Being open source is important to build trust with users but is not a strict
                        requirement of the Data Fund. We&apos;re glad that Swash has done this and
                        we will always encourage other builders to do the&nbsp;same.
                    </p>
                </FaqItem>
                <FaqItem
                    question={
                        <>
                            What level of support can Streamr provide in setting up a
                            Data&nbsp;Union?
                        </>
                    }
                >
                    <p>
                        Building a Data Union is not easy. Partly it&apos;s about tech, and there
                        are a number of developer tools, video tutorials and technical documentation
                        to help. Our Growth team, including our Head of Developer Relations, Matthew
                        Fontana, is also happy to jump on a call to guide you through any technical
                        issue or to just chat through a business idea. Our developer forum is also
                        there as a repository of information for past learnings.
                    </p>
                    <p>
                        But as our first Data Union, Swash, has grown, we&apos;ve realised that
                        building up your user base and also connecting with potential data buyers
                        are also integral parts of building a Data Union. That&apos;s why we have
                        extra resources available including market research and access to our Data
                        Union advisory board who can provide advice and mentorship on growing your
                        user base, legal and policy issues, and negotiating data sales.
                    </p>
                </FaqItem>
            </PersonaPageFaq>
        </Spacer>
    </Layout>
)

export default DataFund
